import React, { useEffect, useRef, useState } from "react";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../../Common/Axios/axiosInstance";
import API from "../../Common/Endpoint/serviceConstrants";
import { buildOrderPayload } from "./utils/buildOrderPayload";
import { useOrderFlow } from "./hooks/useOrderFlow";
import { useCartPricing } from "./hooks/useCartPricing";
import { useCardRedemption } from "./hooks/useCardRedemption";
import { useFingerprint } from "./hooks/useFingerprint";
import {
  onShowFailureReset,
  onShowThankYou,
} from "../../Store/Slices/cardDataSlice";
import {
  allZero,
  calculateEarning,
  ClientInfo,
  Dispatch,
  LoginV3Data,
  MaxQuan,
  OrderData,
  showMaxMessg,
  useClientConfigFlag,
  useEarnRoiCalculationContext,
} from "../Utility/Utility";
import { useCheckoutAnalytics } from "./hooks/useCheckoutAnalytics";
import { useSelector } from "react-redux";
import { useCheckoutContext } from "./context/CheckoutContext";
import { getMinPrice } from "../../Common/HOC/Hoc";
import UserInfoAccordion from "./components/UserInfoAccordion";
import ProductInfoAccordions from "./components/ProductInfoAccordions";
import RedemptionConsent from "./components/RedemptionConsent";
import BuyNowButton from "./components/BuyNowButton";
import { sanitizeRewardValues } from "./utils/rewardCapabilities";
import {
  calculatePercentagePoints,
  getRewardRoundingSettings,
} from "./utils/rewardRounding";
import { getMinimumRewardingOrderEligibility } from "./utils/rewardEligibility";


const CheckoutPage = () => {
  const {
    totalPayableAmount,
    productData,
    productReducer,
    quantities,
    updatedData,
    burnPoints: storedBurnPoints,
    earnPoints: storedEarnPoints,
    effectiveEarn,
    effectiveBurn,
    cash,
    setCash,
    setLoading,
    setPoints,
    setBurnPoints,
    convenienceFee,
    gst,
    setTotalPayableAmount,
    isHostedPayUCancelReturn,
    selectedCardBasedRedemtion,
    setCardBalances,
  } = useCheckoutContext();

  const translation = getTranslationData();
  const dispatch = Dispatch();
  const maxQuan = MaxQuan();
  const orderData = OrderData();
  const clientInfo = ClientInfo();
  const loginV3Data = LoginV3Data();
  const {
    earnPoints,
    burnPoints,
  } = sanitizeRewardValues({
    effectiveEarn,
    effectiveBurn,
    earnPoints: storedEarnPoints,
    burnPoints: storedBurnPoints,
  });

  const { fingerprint } = useFingerprint();

  const [productSupplierMargin, setProductSupplierMargin] = useState([]);
  const [isRedemptionChecked, setIsRedemptionChecked] = useState(true);
  const surlLocation = window?.location.href;
  
  
  const validateLoginTokenData =
    useSelector((state) => state?.validateLoginTokenSliceReducer.data) || {};

  const cardListData = useSelector((state) => state.clientConfigDataReducer);
  const { trackAddPaymentInfo } = useCheckoutAnalytics({ cardListData, productReducer });
  const categoryData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData,
  );
  const checkoutProduct = productReducer?.productReducer;
  const checkoutCategoryId =
    checkoutProduct?.clientCategoryId ?? checkoutProduct?.categoryId;
  const category =
    checkoutProduct?.clientCategoryName ||
    categoryData?.find(
      (findData) => String(findData?.id) === String(checkoutCategoryId),
    )?.name ||
    "";
  const matchedSupplierMargins = productSupplierMargin.filter(
    (item) => item.productId === productReducer?.productReducer?.id,
  );

  const {
    journeyType,
    MatchedCardMasterData,
    razorPayOfferCode,
    payuOfferCode,
  } = useCardRedemption({ clientInfo, selectedCardBasedRedemtion });

  const isWalletJourney =
    journeyType === true ||
    journeyType === 1 ||
    String(journeyType).trim().toLowerCase() === "true" ||
    String(journeyType).trim() === "1";
  const isCardJourney = !isWalletJourney;
  const rewardRoiCalculationContext = useEarnRoiCalculationContext({
    selectedLmsCard: selectedCardBasedRedemtion,
    cardMasterConfiguration: MatchedCardMasterData,
  });

  const supplierMargin = matchedSupplierMargins?.[0]?.supplierMargin;
  const clientConfigurations = clientInfo?.clientData?.clientConfigurations;
  const paymentConfig = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "checkout_display_config",
  )?.configValue;
  const isEarnView = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearnview",
  )?.configValue;
  const clientConfigData = useSelector(
    (state) => state.clientConfigurationReducer?.clientConfigurationData[0],
  );
  const redemptionFeeApplied = clientConfigData?.redemptionApplied;
  const isHtmlHostedPayu = useClientConfigFlag("isHtmlHostedPayu");

  const {
    onlyCash,
    cashPlusPoints,
    paymentMode,
    totalQuantity,
    totalPaid,
    payableAmount,
    isTransactionLimitExceeded,
    earnMinDeno,
    burmMinDeno,
    clientCommissionData,
    showRedemptionFee,
    isRedemptionRequired,
  } = useCartPricing({
    totalPayableAmount,
    burnPoints,
    updatedData,
    quantities,
    convenienceFee,
    gst,
    productData,
    redemptionFeeApplied,
    MatchedCardMasterData,
  });

  const flow2 = clientInfo?.otpConfig === 2;

  const { isEligible: isMinimumRewardingOrderEligible } =
    getMinimumRewardingOrderEligibility({
      checkoutValue: payableAmount,
      minimumRewardingOrderValue:
        MatchedCardMasterData?.minimumRewardingOrderValue,
    });
  const isEarnEligibleForOrder =
    (isWalletJourney || effectiveEarn) && isMinimumRewardingOrderEligible;
  const orderEarnPoints = isEarnEligibleForOrder ? earnPoints : 0;

  let OrderPayload = buildOrderPayload({
    loginV3Data,
    validateLoginTokenData,
    totalPayableAmount,
    onlyCash,
    cashPlusPoints,
    isEarnEnabledForSelectedCard: isEarnEligibleForOrder,
    isBurnEnabledForSelectedCard: effectiveBurn,
    isEarnView,
    earnPoints: orderEarnPoints,
    burnPoints,
    supplierMargin,
    clientCommissionData,
    totalPaid,
    category,
    paymentMode,
    convenienceFee,
    gst,
    updatedData,
    productReducer,
    earnMinDeno,
    burmMinDeno,
    journeyType,
    selectedCardBasedRedemtion,
    showRedemptionFee,
    isRedemptionChecked,
    fingerprint,
  });

  const { handleOrder, handleUpdateOrder } = useOrderFlow({
    dispatch,
    getOrderPayload: () => OrderPayload,
    orderData,
    flow2,
    totalPayableAmount,
    cash,
    convenienceFee,
    gst,
    setPoints,
    setBurnPoints,
    setCash,
    setTotalPayableAmount,
    setLoading,
    setCardBalances,
    journeyType,
    loginV3Data,
    validateLoginTokenData,
    selectedCardBasedRedemtion,
    razorPayOfferCode,
    payuOfferCode,
    MatchedCardMasterData,
    paymentConfig,
    productReducer,
    updatedData,
    burnPoints,
    earnPoints: orderEarnPoints,
    translation,
    isHtmlHostedPayu,
    surlLocation
  });

  const hasSubmittedHostedCancel = useRef(false);
  useEffect(() => {
    if (!isHostedPayUCancelReturn || hasSubmittedHostedCancel.current || !updatedData.length || totalPayableAmount <= 0 ) {
      return;
    }

    const submissionKey = "PayUHostedCancelUpdateSubmitted";
    if (sessionStorage.getItem(submissionKey) === "true") return;

    hasSubmittedHostedCancel.current = true;
    sessionStorage.setItem(submissionKey, "true");
    handleUpdateOrder(undefined, true, false, true, false, "failed");

  }, [handleUpdateOrder, isHostedPayUCancelReturn, totalPayableAmount, updatedData ]);

  useEffect(() => {
    const cached = sessionStorage.getItem("supplier_margin");
    if (cached) {
      setProductSupplierMargin(JSON.parse(cached));
      return;
    }
    const fetchSupplierMargin = async () => {
      const res = await axiosInstance.get(API.supplier_margin);
      if (res?.data?.response) {
        sessionStorage.setItem(
          "supplier_margin",
          JSON.stringify(res.data.response),
        );
        setProductSupplierMargin(res.data.response);
      }
    };
    fetchSupplierMargin();
  }, []);

  useEffect(() => {
    document.body.classList.add("checkout-page-active");
    return () => {
      document.body.classList.remove("checkout-page-active");
    };
  }, []);

  const toPositiveNumber = (value) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) return 0;
    return parsed;
  };

  const parseBooleanFlag = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (["true", "1", "yes", "y"].includes(normalized)) return true;
      if (["false", "0", "no", "n"].includes(normalized)) return false;
    }
    return false;
  };

  const getClientConfigValue = (key) => {
    const config = clientConfigurations?.find(
      (item) => String(item?.configKey || "").toLowerCase() === key.toLowerCase(),
    );
    return config?.configValue;
  };

  const getNormalizedBurnConfig = () => {
    const hasConfiguredFlag = (value) =>
      value !== undefined && value !== null && value !== "";

    const hasAnyBurnConfig = (config) =>
      [
        config?.enableMinBurn,
        config?.minBurnType,
        config?.minBurnValue,
        config?.enableMaxBurn,
        config?.maxBurnType,
        config?.maxBurnValue,
      ].some(hasConfiguredFlag);

    const clientBurnConfig = {
      enableMinBurn:
        clientConfigData?.enableMinBurn ?? getClientConfigValue("enableminburn"),
      minBurnType:
        clientConfigData?.minBurnType ?? getClientConfigValue("minburntype"),
      minBurnValue:
        clientConfigData?.minBurnValue ?? getClientConfigValue("minburnvalue"),
      enableMaxBurn:
        clientConfigData?.enableMaxBurn ?? getClientConfigValue("enablemaxburn"),
      maxBurnType:
        clientConfigData?.maxBurnType ?? getClientConfigValue("maxburntype"),
      maxBurnValue:
        clientConfigData?.maxBurnValue ?? getClientConfigValue("maxburnvalue"),
    };

    const cardBurnConfig = MatchedCardMasterData || {};

    const resolveBurnRule = (prefix) => {
      const isMinimum = prefix === "min";
      const enableKey = isMinimum ? "enableMinBurn" : "enableMaxBurn";
      const typeKey = isMinimum ? "minBurnType" : "maxBurnType";
      const valueKey = isMinimum ? "minBurnValue" : "maxBurnValue";
      const cardRuleValue = Number(
        String(cardBurnConfig?.[valueKey] ?? 0).replace("%", "").trim(),
      );
      const cardHasRule = parseBooleanFlag(cardBurnConfig?.[enableKey])
        && hasConfiguredFlag(cardBurnConfig?.[typeKey])
        && Number.isFinite(cardRuleValue)
        && cardRuleValue > 0;
      const ruleSource = cardHasRule ? cardBurnConfig : clientBurnConfig;

      return {
        [enableKey]: ruleSource?.[enableKey],
        [typeKey]: ruleSource?.[typeKey],
        [valueKey]: ruleSource?.[valueKey],
      };
    };

    const source = isCardJourney
      ? {
        ...resolveBurnRule("min"),
        ...resolveBurnRule("max"),
      }
      : clientBurnConfig;

    if (!hasAnyBurnConfig(source)) {
      return null;
    }

    return {
      enableMinBurn: parseBooleanFlag(source?.enableMinBurn),
      minBurnType: String(source?.minBurnType || "").toLowerCase(),
      minBurnValue: toPositiveNumber(source?.minBurnValue),
      enableMaxBurn: parseBooleanFlag(source?.enableMaxBurn),
      maxBurnType: String(source?.maxBurnType || "").toLowerCase(),
      maxBurnValue: toPositiveNumber(source?.maxBurnValue),
    };
  };

  const formatPoints = (value) => Number(value || 0).toLocaleString();

  const getGrossPayableAmount = () => {
    const baseAmount = (updatedData ?? []).reduce(
      (sum, item) =>
        sum + Number(item?.you_pay || 0) * Number(item?.quantity || 0),
      0,
    );
    return baseAmount + Number(convenienceFee || 0) + Number(gst || 0);
  };

  const getOrderPointsEquivalent = (orderAmount) => {
    const priceDenominations =
      productReducer?.productReducerDisocount?.clientProductDenomination?.map(
        (denomination) => denomination?.denomination,
      ) || [];
    const minPriceDenomination = getMinPrice(priceDenominations);
    const maxEarnPoints = Number(productData?.maxEarnPoints || 0);

    // Card redemption uses the selected card's burn ROI. The product's
    // MaxEarnPoints is only a legacy conversion input for wallet journeys.
    if (!isCardJourney && (!minPriceDenomination || !maxEarnPoints)) return 0;

    const roundingSettings = getRewardRoundingSettings(
      clientConfigData?.pointRoundingConfiguration,
    );
    return calculateEarning({
      ...rewardRoiCalculationContext,
      amount: orderAmount,
      minBurnPoints: maxEarnPoints,
      baseDenomination: minPriceDenomination,
      burnRoundMethod: roundingSettings?.roundMethod,
      burnRoundDigits: roundingSettings?.roundDigits,
    }).pointsRequired;
  };

  const getBurnValidationMessage = () => {
    const burnConfig = getNormalizedBurnConfig();
    if (!burnConfig) {
      return "";
    }

    const selectedPoints = Number(burnPoints || 0);

    // Explicitly preserve existing flow when no points are selected.
    if (selectedPoints === 0) {
      return "";
    }

    const grossPayableAmount = getGrossPayableAmount();
    const orderPointsEquivalent = getOrderPointsEquivalent(
      grossPayableAmount,
    );
    const percentageBurnBase = orderPointsEquivalent;

    const minBurnType = burnConfig.minBurnType;
    const maxBurnType = burnConfig.maxBurnType;

    const minBurnValue = burnConfig.minBurnValue;
    const maxBurnValue = burnConfig.maxBurnValue;
    const roundingSettings = getRewardRoundingSettings(
      clientConfigData?.pointRoundingConfiguration,
    );

    const effectiveMin =
      minBurnType === "percentage"
        ? percentageBurnBase > 0
          ? calculatePercentagePoints({
            percentageBase: percentageBurnBase,
            percentage: minBurnValue,
            roundMethod: roundingSettings?.roundMethod,
            roundDigits: roundingSettings?.roundDigits,
          })
          : 0
        : minBurnValue || 0
      ;
    const effectiveMax =
      maxBurnType === "percentage"
        ? percentageBurnBase > 0
          ? calculatePercentagePoints({
            percentageBase: percentageBurnBase,
            percentage: maxBurnValue,
            roundMethod: roundingSettings?.roundMethod,
            roundDigits: roundingSettings?.roundDigits,
          })
          : 0
        : maxBurnValue || 0

    if (

      effectiveMin > 0 &&
      selectedPoints < effectiveMin
    ) {
      if (minBurnType === "percentage") {
        return `${translation?.min_max_redeem_percentage_minimum} ${minBurnValue}% ${translation?.redeem_transaction_value_points}`;
      }
      return `${translation?.min_max_redeem_points_minimum} ${formatPoints(minBurnValue)} ${translation?.redeem_points_label}`;
    }

    if (

      effectiveMax > 0 &&
      selectedPoints > effectiveMax
    ) {
      if (maxBurnType === "percentage") {
        return `${translation?.min_max_redeem_percentage_maximum} ${maxBurnValue}% ${translation?.redeem_transaction_value_points}`;
      }
      return `${translation?.min_max_redeem_points_maximum} ${formatPoints(maxBurnValue)} ${translation?.redeem_points_label}`;
    }
    return "";
  };

  const handleSubmit = () => {
    const memberId = loginV3Data?.memberIdentifier;
    if (!memberId) {
      toast.error(translation?.ReLoginAtCheckoutPage);
      return;
    }
    dispatch(onShowFailureReset());
    dispatch(onShowThankYou());
    if (maxQuan > 0 && totalQuantity > maxQuan) {
      showMaxMessg(translation.max_limit_allowed, maxQuan);
      return;
    } else if (allZero(quantities)) {
      toast.error(translation?.pleaseAddSomeProductsQuantitys);
      return;
    }

    const burnValidationMessage = getBurnValidationMessage();
    if (burnValidationMessage) {
      toast.error(burnValidationMessage);
      return;
    }

    handleOrder();

    trackAddPaymentInfo({
      totalPayableAmount,
      convenienceFee,
      updatedData,
      orderPayload: OrderPayload,
    });
  };

  return (
    <div className="checkout-page-active">
      <ToastContainer />
      <div className="mt-3 checkout-page">
        <UserInfoAccordion journeyType={journeyType} />
        <ProductInfoAccordions />
        <RedemptionConsent
          showRedemptionFee={showRedemptionFee}
          isChecked={isRedemptionChecked}
          onChange={setIsRedemptionChecked}
        />
        <BuyNowButton
          onSubmit={handleSubmit}
          isTransactionLimitExceeded={isTransactionLimitExceeded}
          isRedemptionRequired={isRedemptionRequired}
          isRedemptionChecked={isRedemptionChecked}
          journeyType={journeyType}
        />
      </div>
    </div>
  );
};

export default CheckoutPage;
